<template lang="pug">
include /mixins
+b.card-product-inner--left(
  :class="classes"
)
  ui-loader(v-if='localload')
  product-set-view(
    v-if='isSetCard'
    :set='set'
    :complect="complect"
    :id='id'
    v-on='productListeners'
    :gifts='cart.gifts[id]'
    :is-cart-modal="isCartModal"
  )
  template(v-else)
    product-set-view-simple(
      :set='set'
      :id='id'
      v-on='productListeners'
      :gifts='cart.gifts[id]'
    )
    template(v-for='item, index in cart.gifts')
      component(
        :is="!hasChoice(item) ? 'product-set-of-gifts-view-dropdown' : 'product-set-of-gifts-view' "
        :key-for-reload="keyForReload"
        v-if='index == id'
        :set='item'
        :id='id'
      )

</template>
<script>
import { mapActions, mapState } from 'vuex'
import { confirmWithPromise } from '@utils/helpers'

import ProductSetView from './Variants/Set'
import ProductSetViewSimple from './Variants/SetSimple'
import ProductSetOfGiftsView from './Variants/SetOfGifts'
import ProductSetOfGiftsViewDropdown from './Variants/SetOfGiftsDropdown'

export default {
  name: 'ProductSetUi',
  components: {
    ProductSetView,
    ProductSetViewSimple,
    ProductSetOfGiftsView,
    ProductSetOfGiftsViewDropdown,
  },
  props: {
    keyForReload: {
      default: 0
    },
    set: {
      default: () => { },
    },
    complect: {
      default: () => { },
    },
    load: {},
    id: {},
    classes: '',
    isSetCard: {
      default: false,
    },
    isCartModal: {
      default: () => false,
    },
  },
  data() {
    return {
      localload: false,
      inWork: false,
    }
  },

  computed: {
    ...mapState('cart', [
      'cart',
    ]),
    campaignInfo() {
      const [, id, number] = this.id.split('_')
      return this.cart.parameters.complects_info
        .find(i => i.campaign_id === Number(id) && i.number_complect === Number(number))
    },
    test(event) {
      console.log(event);
    },
    productListeners() {
      return {
        ...this.$listeners,
        removeFromCart: () => this.removeFromCart(),
        updateCart: event => { 
          this.updateCart(event)
        },
      }
    },
    productProps() {
      const { relations, base, price } = this.product
      return {
        load: this.load,
        product: base,
        relations,
        price,
        disabled: this.$attrs.disabled,
      }
    },
  },
  methods: {
    ...mapActions('cart', [
      'changeCart',
    ]),
    hasChoice(set) {
      return !!set?.[0]?.base?.parameters?.quantity_gift_select
    },
    async updateCart({ info, campaign }) {
      const changes = info.count - this.campaignInfo.complect_count
      console.log(changes);
      if (!changes) return
      if (this.inWork) return
      this.inWork = true
      this.localload = true
      const entities = this.set.reduce((acc, variant) => {
        const init = variant.base.quantity / this.campaignInfo.complect_count
        acc.push({
          element: {
            id: variant.base.element.id,
            type: variant.base.element.type,
          },
          item_id: variant.base.id,
          parameters: {
            number_complect: this.campaignInfo.number_complect,
          },
          quantity: changes * init,
        })
        return acc
      }, [])
      this.changeCart({ data: { entities }, retrieve: true })
        .then(() => {
          this.$nextTick(() => {
            this.localload = false
            this.$emit('cart:update')
            this.inWork = false
          })
        }, err => {
          this.inWork = false
          this.localload = false
        })
    },
    async removeFromCart() {
      const question = this._('Вы действительно хотите удалить товар с корзины?')
      try {
        await confirmWithPromise(question, this)
        const count = -1
        const obj = {
          count,
        }
        this.updateCart({ info: obj, campaign: { complect_count: 0 } }, true)
      } catch (e) {
      }
    },
  },
}
</script>
